import Vue from 'vue';

import Offset from './helper/Offset';

Vue.component('helper-offset', Offset);
